import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import { Edited } from './modals/Edited';
import dialogLoader from '../utilities/dialogLoader';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import Confirmation from '../components/modals/common/Confirmation';
import WorkDatesService from '../services/WorkDates';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS, DIALOG_STATUS } from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';

const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
export class WorkDates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      currentYear: null,
      currentMonth: null,
      workDates: [],
      changeMonth: null,
      isUnchanged: true, // 稼働日が更新したかどうか
      dialogStatus: DIALOG_STATUS.disabled.id,
      checkedWeekOfDays: new Map(),
    };
    this.isUpdating = false; // 更新ボタン連打防止
    this.formatYMD = 'YYYY/MM/DD';
    this.events = {
      table: {
        moveCal: this.moveCal.bind(this),
        dateClick: this.dateClick.bind(this),
        weekDayClick: this.weekDayClick.bind(this),
        checkIfUnchanged: this.checkIfUnchanged.bind(this),
      },
      form: {
        submit: this.eventSubmit.bind(this),
      },
    };
  }

  async componentDidMount() {
    const year = moment().year();
    const month = moment().month() + 1;
    const workDates = await this.getWorkDates(year, month);
    const checkedItem = this.calcCheckedItem(workDates);
    // 稼働日が更新したことがある場合
    const unchanged = this.checkIfUnchanged(workDates);
    this.setState({
      currentYear: year,
      currentMonth: month,
      workDates,
      checkedWeekOfDays: checkedItem,
      isUnchanged: unchanged,
    });
  }

  /**
   * 曜日のうち、全て非稼動日になっている曜日を返す
   */
  calcCheckedItem(workDates) {
    // 稼動日を含む曜日を特定
    const includeWorkDate = [];
    workDates.forEach((workDate, index) => {
      if (!includeWorkDate.includes(moment(workDate.work_date).day())) {
        if (workDates[index].holiday_flag !== 1) {
          includeWorkDate.push(moment(workDate.work_date).day());
        }
      }
    });
    // 稼動日を含む曜日以外は、全て非稼動日の曜日
    const dayOfWeekIndexArr = dayOfWeek.map(function(day, index) {
      return index;
    });
    const checkedRequiredDayOfWeek = dayOfWeekIndexArr.filter(
      (item, index) => includeWorkDate.indexOf(index) === -1
    );
    // stateのcheckedWeekOfDaysにそのまま使えるよう加工
    const checkedItem = new Map();
    if (checkedRequiredDayOfWeek.length > 0) {
      checkedRequiredDayOfWeek.forEach(item => {
        checkedItem.set(item, true);
      });
    }
    return checkedItem;
  }

  async moveCal(e, movePoint) {
    const nextDate = moment(
      `${this.state.currentYear}/${this.state.currentMonth}/01`
    ).add('months', movePoint);
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month() + 1;
    const workDates = await this.getWorkDates(nextYear, nextMonth);
    const checkedItem = this.calcCheckedItem(workDates);
    // 稼働日が更新したことがある場合
    const unchanged = this.checkIfUnchanged(workDates);

    this.setState({
      currentYear: nextYear,
      currentMonth: nextMonth,
      workDates,
      isUnchanged: unchanged,
      checkedWeekOfDays: checkedItem,
    });
  }
  dateClick(e, index) {
    const workDates = _.cloneDeep(this.state.workDates);
    workDates[index].holiday_flag = workDates[index].holiday_flag === 0 ? 1 : 0;
    this.setState({
      workDates,
    });
  }

  updateCheckedWeekOfDay(weekDay, isChecked) {
    const checkedItem = new Map(this.state.checkedWeekOfDays);
    checkedItem.set(weekDay, isChecked);
    return checkedItem;
  }
  weekDayClick = (e, weekDay) => {
    const workDates = _.cloneDeep(this.state.workDates);
    const isChecked = e.target.checked;
    _.each(workDates, (workDate, index) => {
      if (moment(workDate.work_date).day() === weekDay) {
        workDates[index].holiday_flag = isChecked ? 1 : 0;
      }
    });
    this.setState({
      workDates,
      checkedWeekOfDays: this.updateCheckedWeekOfDay(weekDay, isChecked),
    });
  };

  async getWorkDates(year, month) {
    const fieldId = this.state.fieldId;
    const dateFrom = moment(`${year}/${month}/01`).format(this.formatYMD);
    const dateTo = moment(`${year}/${month}/01`)
      .endOf('month')
      .format(this.formatYMD);
    const params = {
      date_from: dateFrom,
      date_to: dateTo,
    };
    return WorkDatesService.list(fieldId, params)
      .then(resp => {
        // statusは0が返っている
        if (resp.result) {
          const date = moment(`${year}/${month}/01`);
          const workDateList = [];
          const work_dates = resp.data.entities.work_dates;
          while (date.month() + 1 === month) {
            const index = _.findIndex(work_dates, [
              'work_date',
              date.format('YYYY/MM/DD'),
            ]);
            if (index > -1) {
              workDateList.push(work_dates[index]);
            } else {
              workDateList.push({
                field_id: fieldId,
                work_date: date.format('YYYY/MM/DD'),
                holiday_flag: 0,
              });
            }
            date.add('day', 1);
          }
          return workDateList;
        }
        throw new Error(messageUtility.getMessage('E-000-001'));
      })
      .catch(e => {
        console.error(e);
        window.location.replace('/error-500');
      });
  }

  eventSubmit = () => {
    if (this.isUpdating) {
      return;
    }
    this.isUpdating = true;
    const fieldId = this.state.fieldId;
    const values = { work_dates: this.state.workDates };
    WorkDatesService.update(fieldId, values)
      .then(async resp => {
        if (resp.result) {
          dialogLoader.show(Edited, {
            callback: {
              done: () => {
                this.isUpdating = false;
              },
            },
          });
          const workDates = await this.getWorkDates(
            this.state.currentYear,
            this.state.currentMonth
          );
          this.setState({
            workDates,
          });
        } else {
          dialogLoader.show(ErrorDialog, {
            message: messageUtility.getMessage('E-000-005'),
            callback: {
              close: () => {
                this.isUpdating = false;
                dialogLoader.close();
              },
            },
          });
        }
      })
      .catch(e => {
        console.error(e);
        window.location.replace('/error-500');
        this.isUpdating = false;
      });
  };
  // eは、movecal functionで使われる値である。
  // iは、月を翌月に変更するか、前月に変更するかを決定するための変数である。
  monthChange = async (i, e) => {
    const { workDates, currentYear, currentMonth } = this.state;
    const fetchedWorkDates = await this.getWorkDates(currentYear, currentMonth);
    //示しているデータが保存されているデータと違う場合
    const unchanged = this.checkIfUnchanged(workDates);
    if (!_.isEqual(workDates, fetchedWorkDates)) {
      this.setState({
        dialogStatus: DIALOG_STATUS.cancelEditDialogEnabled.id,
        isUnchanged: unchanged,
        changeMonth: i,
      });
    } else {
      await this.events.table.moveCal(e, i);
    }
  };
  // 「変更した内容を保存しますか？」ポップアップをクローズする
  closeDialog = () => {
    this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
  };
  // 稼働日が更新したことがあるかどうか確認
  checkIfUnchanged(workDates) {
    let unchanged = true;
    workDates.forEach((workDate, index) => {
      if (workDates[index].created_at != null) {
        unchanged = false;
      }
    });
    return unchanged;
  }

  render() {
    const calenderDateList = () => {
      const currentYear = this.state.currentYear;
      const currentMonth = this.state.currentMonth;
      if (currentYear === null || currentMonth === null) {
        return [];
      }
      const startDate = moment(`${currentYear}/${currentMonth}/01`);
      const month = startDate.month();
      const date = moment(`${currentYear}/${currentMonth}/01`);
      const calender = [];
      let week = [];
      // 1日までは空白
      for (let wd = 0; wd < date.day(); wd++) {
        week.push({});
      }
      // 日付を設定
      while (date.month() === month) {
        if (date.day() === 0 && date.date() !== 1) {
          calender.push(week);
          week = [];
        }
        week.push({
          key: date.date() - 1,
          year: date.year(),
          month: date.month() + 1,
          date: date.date(),
          day: date.day(),
        });
        date.add('day', 1);
      }
      // 末日後は土曜日まで空白とする
      if (date.day() !== 0) {
        for (let wd = date.day(); wd <= 6; wd++) {
          week.push({});
        }
      }
      calender.push(week);
      return calender;
    };

    return (
      <div className='setting-main__body' style={{ height: '660px' }}>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 稼働日設定</title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          <div className='setting-header__item'>
            <button
              className='btn--effective'
              onClick={() => {
                this.events.form.submit();
                this.setState({
                  isUnchanged: false,
                });
              }}
            >
              更新
            </button>
          </div>
        </div>
        <div className='work-day'>
          <div className='calender-header'>
            <div className='calender-header__prev-month'>
              <button
                className='btn--sm--stay'
                onClick={() => {
                  this.monthChange(-1);
                }}
              >
                {'< 前月'}
              </button>
            </div>
            <div className='calender-header__title'>
              {' '}
              {this.state.currentYear} / {this.state.currentMonth}
            </div>
            <div className='calender-header__next-month'>
              <button
                className='btn--sm--stay'
                onClick={() => {
                  this.monthChange(1);
                }}
              >
                {'翌月 >'}
              </button>
            </div>
          </div>
          {/* 変更した内容を保存しますか？」ダイアログボックス */}
          <Confirmation
            visible={
              this.state.dialogStatus ===
              DIALOG_STATUS.cancelEditDialogEnabled.id
            }
            title='変更した内容を保存しますか？'
            confirmButtonText='保存する'
            cancelButtonText='保存しない'
            message='変更した内容は保存されません。表示される月を変更してよろしいですか？'
            onConfirm={e => {
              this.events.form.submit();
              this.events.table.moveCal(e, this.state.changeMonth);
              this.closeDialog();
            }}
            onCancel={e => {
              this.closeDialog();
              this.events.table.moveCal(e, this.state.changeMonth);
            }}
          />
          <table className='calender'>
            <thead>
              <tr className='calender__label'>
                {dayOfWeek.map((weekday, index) => (
                  <th key={index} className='calender__day'>
                    <div className='calender-label'>
                      <div className='calender-label__day'>{weekday}</div>
                      <div className='calender-label__checkbox'>
                        <div className='btn-checkbox'>
                          <label htmlFor={`sys-select-col-${index}`}>
                            <input
                              id={`sys-select-col-${index}`}
                              className='calender-label__all-check'
                              type='checkbox'
                              checked={
                                this.state.checkedWeekOfDays.has(index)
                                  ? this.state.checkedWeekOfDays.get(index)
                                  : false
                              }
                              onClick={e =>
                                this.events.table.weekDayClick(e, index)
                              }
                            />
                            <i className='i-square i-3x' />
                          </label>
                        </div>
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody id='work-calender-body'>
              {this.state.workDates &&
                calenderDateList().map((weekRow, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={`calender__week sys-row${rowIndex}`}
                  >
                    {weekRow.map((dateData, index) => {
                      if (dateData.key >= 0) {
                        return (
                          <td
                            key={`key__rowIndex-${rowIndex}-index-${index}`}
                            className='calender__day'
                          >
                            <label
                              id={`work-click-${dateData.key}`}
                              htmlFor={`calender-${dateData.key}`}
                              onClick={e =>
                                this.events.table.dateClick(e, dateData.key)
                              }
                              className={`calender-day sys-enable-col-${dateData.key} enable`}
                            >
                              <input
                                type='checkbox'
                                readOnly
                                checked={
                                  this.state.workDates[dateData.key]
                                    .holiday_flag === 0
                                    ? true
                                    : false
                                }
                                className='sys-row-1 sys-col-3'
                              />
                              <div
                                // 稼働日が更新したことがある場合、classNameが変わる(色が変わる)
                                // 緑色の日付は稼働日設定のページにしか使用しない
                                className={
                                  this.state.isUnchanged
                                    ? 'calender-day__number calender-day__number--unchanged'
                                    : 'calender-day__number calender-day__number--workdate'
                                }
                              >
                                {dateData.date}
                              </div>
                            </label>
                          </td>
                        );
                      } else {
                        return (
                          <td
                            key={`key__rowIndex-${rowIndex}-index-${index}`}
                            className='calender__day'
                          >
                            <label
                              htmlFor={`calender-${index}`}
                              className={`calender-day sys-enable-col-${index}`}
                            >
                              <input
                                id='work-calender--'
                                type='checkbox'
                                checked={false}
                                className=''
                              />
                              <div className='calender-day__number'>-</div>
                            </label>
                          </td>
                        );
                      }
                    })}
                  </tr>
                ))}
            </tbody>
          </table>
          <div className='calender-footer'>
            <ul className='calender-footer__menu'>
              <li>
                <span className='color-chip--notset' />
                <span className='label'>未設定</span>
              </li>
              <li>
                <span className='color-chip--active calender-footer__color-chip--active' />
                <span className='label'>稼働日</span>
              </li>
              <li>
                <span className='color-chip--inactive' />
                <span className='label'>非稼働日</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/WorkDates.jsx